import { useEffect } from 'react';
import { HubConnection } from '@microsoft/signalr';

import { ISignalRRoomTarget, signalRRoomMembership } from './signalRRoomMembership';

export const useSignalRResourceRoom = (
    connection: HubConnection | null | undefined,
    target: ISignalRRoomTarget | null
) => {
    const kind = target?.kind;
    const resourceType = target?.resourceType;
    const resourceId = target?.resourceId;

    useEffect(() => {
        if (!connection || !kind || !resourceType || !resourceId) {
            return undefined;
        }

        return signalRRoomMembership.retain(connection, {
            kind,
            resourceType,
            resourceId
        });
    }, [connection, kind, resourceType, resourceId]);
};
